export enum CustomerTypeEnum {
  Company = 'company',
  Personal = 'personal',
}
